'use client';

import { styled } from '@linaria/react';

import { normalize } from '@/utils';

import Demo, { DemoSliderControl } from '@/components/Demo';

function ButtonLayersWithShadow() {
  return (
    <Demo
      id="button-layers"
      initialValues={{ expose: 0 }}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
      controls={[
        <DemoSliderControl
          key="expose"
          id="expose"
          label="Reveal"
          min={0}
          max={100}
        />,
      ]}
    >
      {({ expose }) => {
        const rotate = normalize(expose, 0, 100, 0, -45);
        const faceOpacity = normalize(expose, 0, 100, 1, 0.75);
        const n = (min, max) => normalize(expose, 0, 100, min, max);

        return (
          <Wrapper>
            <ButtonWrapper
              style={{
                transform: `rotateY(${rotate}deg)`,
              }}
            >
              <ShadowWrapper
                style={{
                  transform: `translate3D(
                    ${n(0, 20)}px,
                    ${n(0, 3)}px,
                    ${n(0, -15)}px
                  )`,
                }}
              >
                <Shadow />
              </ShadowWrapper>
              <Backdrop />
              <FaceWrapper
                style={{
                  transform: `translate3D(
                    ${n(0, -20)}px,
                    ${n(0, -3)}px,
                    ${n(0, 20)}px
                  )`,
                  '--opacity': faceOpacity,
                }}
              >
                <ButtonFace>Push Me</ButtonFace>
              </FaceWrapper>
            </ButtonWrapper>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  perspective: 500px;
  padding: 32px;
`;

const ButtonWrapper = styled.button`
  perspective: inherit;
  transform-style: preserve-3d;
  transform-origin: center center;
`;

const ShadowWrapper = styled.span`
  display: block;
  position: relative;
  transform-origin: center center;
`;
const Shadow = styled.span`
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  background: hsl(0deg 0% 0% / 0.2);
  border-radius: 12px;
  /* Mouse-out styles */
  transform: translateY(3px);
  transition: transform 600ms cubic-bezier(0.3, 0.7, 0.4, 1);

  ${ButtonWrapper}:hover &,
  ${ButtonWrapper}:focus-visible & {
    transform: translateY(4px);
    transition: transform 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);
  }
  ${ButtonWrapper}:active & {
    transform: translateY(1px);
    transition: transform 25ms;
  }
`;

const Backdrop = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: hsl(340deg, 100%, 32%);
  border-radius: 12px;
  transform-origin: center center;
`;

const FaceWrapper = styled.span`
  display: block;
  position: relative;
  transform-origin: center center;
`;

const ButtonFace = styled.span`
  display: block;
  padding: 12px 42px;
  border-radius: 12px;
  border: none;
  background: hsl(345deg 100% 46.5% / var(--opacity));
  color: white;
  font-size: 20px;
  font-weight: 500;
  transform: translateY(-4px);
  /* Mouse-out styles */
  transition: transform 250ms cubic-bezier(0.3, 0.7, 0.4, 1.5);

  ${ButtonWrapper}:hover &,
  ${ButtonWrapper}:focus-visible & {
    transform: translateY(-6px);
    transition: transform 250ms;
  }
  ${ButtonWrapper}:active & {
    transform: translateY(-2px);
    transition: transform 25ms;
  }
`;

export default ButtonLayersWithShadow;
